var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTick = function SvgTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57.457 57.457",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.602 -16.602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.639,40.571a3.424,3.424,0,0,0-4.9,0,3.459,3.459,0,0,0-.171,4.731l10.41,11.27A3.305,3.305,0,0,0,45.468,57.6h.087a3.119,3.119,0,0,0,2.409-1.032L74.2,30.336a3.467,3.467,0,1,0-4.9-4.9L45.636,49.26Z",
    transform: "translate(-2.113 -1.09)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.331,74.059A28.724,28.724,0,0,0,74.059,45.331a3.441,3.441,0,1,0-6.882,0A21.847,21.847,0,1,1,45.331,23.484a3.441,3.441,0,0,0,0-6.882,28.729,28.729,0,1,0,0,57.457Z",
    fill: "currentColor"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick.b8616926.svg";
export { ForwardRef as ReactComponent };